import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { VedaemLanding } from './types';

export function useVedaemLandingData(): Page<VedaemLanding>['templateFields'] {
  return useCurrentPage<Page<VedaemLanding>>().templateFields;
}
